import { createActionGroup, props } from '@ngrx/store';
import { UsageSnapshot } from './models/usage-snapshot.model';

export const UsageSnapshotActions = createActionGroup({
  source: 'Usage Snapshot Effect',
  events: {
    'Get Usage Snapshot Succeeded': props<{ snapshot: UsageSnapshot }>(),
    'Get Usage Snapshot Errored': props<{ error: any }>(),
  },
});
